import { render } from "./WorkWeChatMiniappIntroduce.vue?vue&type=template&id=7a4d0665&scoped=true"
import script from "./WorkWeChatMiniappIntroduce.vue?vue&type=script&lang=js"
export * from "./WorkWeChatMiniappIntroduce.vue?vue&type=script&lang=js"

import "./WorkWeChatMiniappIntroduce.vue?vue&type=style&index=0&id=7a4d0665&lang=scss&scoped=true"

import exportComponent from "D:\\myWork\\SAAS\\Group-Carwins-H5-1.0\\carwins-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a4d0665"]])

export default __exports__